import { ArrowUpSolidIcon } from '@navi/web-ui/lib/icons';
import cx from 'classnames';

interface ArrowButtonComponentProps {
  direction?: boolean;
}

const ArrowButtonComponent = (props: ArrowButtonComponentProps) => {
  const { direction } = props;
  return (
    <ArrowUpSolidIcon
      width={10}
      className={cx({
        'ml-3': true,
        'rotate-180': !direction
      })}
    />
  );
};

export default ArrowButtonComponent;
